import { render, staticRenderFns } from "./dmca.vue?vue&type=template&id=f9ff617c&scoped=true"
import script from "./dmca.vue?vue&type=script&lang=js"
export * from "./dmca.vue?vue&type=script&lang=js"
import style0 from "./dmca.vue?vue&type=style&index=0&id=f9ff617c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ff617c",
  null
  
)

export default component.exports